import type * as ents from '@attain-apps/entities'

export interface State {
  pulse?: State.Entry<ents.core.summit.Pulse | undefined>
  fromDate: Date
}
export namespace State {
  export type Entry<T> = ExactlyOneOf<{
    data: T
    loading: boolean
    error: Error
  }>
  /**
   * Predefined date ranges for pulse data generation.
   * Each option contains:
   * - label: Human-readable description of the time range
   * - value: Date object representing the start of the range (end date is always current date)
   *
   * Available ranges:
   * - Last Week: 7 days from current date
   * - Last Month: 30 days from current date
   * - Last Quarter: 90 days from current date
   */
  export const dateOptions = [
    {
      label: 'Last Week',
      value: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    },
    {
      label: 'Last Month',
      value: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
    },
    {
      label: 'Last Quarter',
      value: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    },
  ]

  export const INITIAL: State = {
    fromDate: dateOptions[0].value,
  }
}
